// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var textHighlightStyle = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.text-highlight': {
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    borderBottom: "2px solid ".concat("var(--ds-background-accent-blue-subtler, #CCE0FF)")
  }
});